import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25bff5e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "async-down-task" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = { style: {"padding":"10px"} }

import { reactive, ref, onMounted, nextTick, toRef } from 'vue'
import { selectAllByPage, downloadExcel } from './api'
import { RefreshRight } from '@element-plus/icons-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'asyncDownTask',
  props: ["exportType"],
  setup(__props) {

const props = __props;

const columns = ref<any>([
    { id: 'taskName', label: '任务名称' },
    { id: 'createdTime', label: '创建时间' },
    { id: 'exportType', label: '导出类型', dic: { "APP_INS_EXPORT": "投保", "CLAIM_EXPORT": "理赔" } },
    // { id: 'taskState', label: '状态', dic: { "0": "处理中", "1": "待下载", "2": "已下载" } },
]);

const exportType = toRef(props, "exportType");
const page = reactive({
    pageIndex: 1,
    pageSize: 10,
    total: 0
})
onMounted(() => {
    getPage()
})
const tableData = ref<any>([])
const handleCurrentChange = (val: number) => {
    getPage(val)
}
const getPage = (pageIndex: number = 1) => {
    if (pageIndex) {
        page.pageIndex = pageIndex;
    }
    console.log('exportType', exportType)
    selectAllByPage({
        pageIndex: page.pageIndex, pageSize: page.pageSize, condition: {
            taskState: ['0', '1', '2'],
            exportType: exportType.value
        }
    }).then((res: any) => {
        tableData.value = res.items
        page.total = Number(res.totalSize)
    })
}
const download = (row: any) => {
    const aLink = document.createElement("a");
    aLink.style.display = "none";
    aLink.href = process.env.NODE_ENV == 'development' ? `${row.downloadUrl}${row.taskName}.zip` : `${row.downloadUrl}${row.taskName}.zip`;
    aLink.download = `${row.taskName}.zip`;
    aLink.click();
    // document.body.removeChild(aLink);
    // downloadExcel({
    //     exportTaskId: row.exportTaskId,
    //     taskName: row.taskName,
    // }).then(res => {
    //     getPage(1)
    // })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(RefreshRight),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (getPage(1)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("刷 新")
        ]),
        _: 1
      }, 8, ["icon"])
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: "",
      stripe: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            prop: col.id,
            align: "center",
            key: col.id,
            label: col.label,
            width: col.width
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(col.dic ? col.dic[scope.row[col.id]] : scope.row[col.id]), 1)
            ]),
            _: 2
          }, 1032, ["prop", "label", "width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _withDirectives(_createVNode(_component_el_button, {
              type: "text",
              onClick: ($event: any) => (download(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("下载")
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_vShow, scope.row.taskState == 1]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_pagination, {
        "current-page": page.pageIndex,
        "onUpdate:current-page": _cache[1] || (_cache[1] = ($event: any) => ((page.pageIndex) = $event)),
        "page-size": page.pageSize,
        "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((page.pageSize) = $event)),
        background: "",
        total: page.total,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ]))
}
}

})